// 下拉刷新
const pullToRefresh = option => {
    if (window.PPDWebUI.os.inApp) {
        let appV = window.PPDWebUI.os.buildVersion;
        let res = versionStringCompare(appV, '9.4.0');
        const defaultOpt = {
            refreshType: 2, // Number类型，0:无下拉刷新；1:下拉刷新，pullToRefreshMethod为null；2:下拉刷新，pullToRefreshMethod为js方法字符串
            pullToRefreshMethod: res >= 0 ? 'reloadH5Page()' : '', // String类型，js脚本
            refreshBackColor: '#E6E4DF'
        };
        const pullToRefreshOption = { ...defaultOpt, ...option };
        PPDWebUI && PPDWebUI.CommonService.pullToRefresh(pullToRefreshOption);
    }
};
const closePullToRefresh = option => {
    const defaultOpt = {
        refreshType: 0, // Number类型，0:无下拉刷新；1:下拉刷新，pullToRefreshMethod为null；2:下拉刷新，pullToRefreshMethod为js方法字符串
        pullToRefreshMethod: '' // String类型，js脚本
    };
    const pullToRefreshOption = { ...defaultOpt, ...option };
    PPDWebUI && PPDWebUI.CommonService.pullToRefresh(pullToRefreshOption);
};
const versionStringCompare = (preVersion = '', lastVersion = '') => {
    let sources = preVersion.split('.');
    let dests = lastVersion.split('.');
    let maxL = Math.max(sources.length, dests.length);
    let result = 0;
    for (let i = 0; i < maxL; i++) {
        let preValue = sources.length > i ? sources[i] : 0;
        let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
        let lastValue = dests.length > i ? dests[i] : 0;
        let lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
        if (preNum < lastNum) {
            result = -1;
            break;
        } else if (preNum > lastNum) {
            result = 1;
            break;
        }
    }
    return result;
};

export default {
    pullToRefresh,
    closePullToRefresh
};
